<template>
	<div >
		<v-stepper v-model="getAuthStep" class="elevation-0">

			<v-stepper-items>
				<v-stepper-content step="1" >
					<div class="text-center">
						<p class="page-title"> FORGET PASSWORD </p>
						<p class="head--text">Fill in your Mobile Number below.</p>
					</div>
					<div class="h-100">
						<v-form ref="forgetpassword_form"  lazy-validation  @submit.prevent="forgetPassword()">
							<v-row justify="center" class="pt-5 text-center">
								<v-col cols="10" md="4" class="px-5">
									<v-text-field
									:label="$lang.MOBILE_NO"
									v-model="mobile"
									single-line
									outlined
									dense
									maxlength="10"
									:rules="$rules.mobileRule"
									></v-text-field>
									<v-btn color="primary" type="submit" class="signup-btn-style mt-5"  :loading="loding">
										{{$lang.CONTINUE}}
									</v-btn>	
								</v-col>
							</v-row>
						</v-form>
					</div>
				</v-stepper-content>


				<!--  VERIFY OTP -->
				<v-stepper-content step="2">
					<verify-otp />
				</v-stepper-content>

				<!--  RESET PASSWORD -->
				<v-stepper-content step="3">
					<reset-password/>
				</v-stepper-content>


			</v-stepper-items>
		</v-stepper>

	</div>
</template>
<script type="text/javascript">
import messages  from '../../../app-js/messages.js'
import { mapGetters } from 'vuex';
export default {
	components: {
		ResetPassword: () => import('../reset-password/ResetPassword.vue'),
		VerifyOtp: () => import('../verify-otp/VerifyOtp.vue'),
	},
	data () {
		return {
			e1:1,
			mobile:"",
			loding:false,

		}
	},
	computed: mapGetters({
		getAuthStep: 'auth/getAuthStep'
	}),
	methods:{
		
		forgetPassword(){
			const self=this;
			if (this.$refs.forgetpassword_form.validate()==false)
				return false
			self.loding=true
			var	form = new FormData();
			form.append("mobile",self.mobile);


			const successHandler = (response) => {
				if (response.data.success){
					this.$store.dispatch('auth/setOtpToken', {otp_token:response.headers["otp-token"], mobile:self.mobile, email:"",action:"reset" })
					this.$store.dispatch('auth/setAuthStep', 2)
					// self.$router.push({name:"verify-otp"})
				}
			};
			const finallyHandler = () => {
				self.loding=false
			};
			
			this.request_POST(self,this.$urls.FORGET_PASSWORD,form,successHandler,null,null,finallyHandler)

		}
		
	}

}

</script>